export const dummyProductList = {
  route: () => import('./DummyProductList.vue'),
  propTypes: {},
};
